import Link from "next/link";

import { links } from "@/data/links";
import { useLang } from "@/hooks/use-lang";

import { Button } from "ui/core/button";

export const SubscribeMaskContent = () => {
  const { t, lang } = useLang();
  return (
    <div className="flex h-full w-full max-w-sm flex-col items-center justify-center gap-2">
      <p className="text-base font-bold">
        {t.blockDialog.subscribe.blog.title}
      </p>
      <p className="text-sm text-slate-500">
        {t.blockDialog.subscribe.blog.description}
      </p>
      <Link
        href={`/${lang}${links.stockMiningPricing}`}
        className="mt-4 w-full"
      >
        <Button className="w-full">
          {t.blockDialog.subscribe.blog.button}
        </Button>
      </Link>
    </div>
  );
};
